import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const MyPreset = definePreset(Lara, {
  components: {
      card: {
          colorScheme: {
              light: {
                  root: {
                      background: '{surface.0}',
                      color: '{surface.700}'
                  },
                  subtitle: {
                      color: '{surface.500}'
                  }
              },
              dark: {
                  root: {
                      background: '{surface.900}',
                      color: '{surface.0}'
                  },
                  subtitle: {
                      color: '{surface.400}'
                  }
              }
          }
      }
  }
});



export default MyPreset;
